// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import cn from 'classnames';
import store from '../../store.js';
import {fmt_money} from '../../utils/misc.js';
import {Text} from '../text';
import {Icon} from '../icon';
import * as cns from './total_earnings.module.less';

const get_tooltip = meta=>{
    const {ref_bonuses_total, promo_bonuses_total,
        ref_bvpn_total, ref_hola_browser_total} = meta;
    let title = '';
    if (ref_bonuses_total)
        title += `including ${fmt_money(ref_bonuses_total)} from my referrals`;
    if (promo_bonuses_total)
    {
        title += title ? ' and ' : 'including ';
        title += `${fmt_money(promo_bonuses_total)} from promotions`;
    }
    if (ref_bvpn_total)
    {
        title += title ? ' and ' : 'including ';
        title += `${fmt_money(ref_bvpn_total)} from my Bright VPN referrals`;
    }
    if (ref_hola_browser_total)
    {
        title += title ? ' and ' : 'including ';
        title += `${fmt_money(ref_hola_browser_total)} from`
            +` my Hola Browser referrals`;
    }
    return title;
};

const get_mult = meta=>{
    const {multiplier, multiplier_icon, multiplier_hint} = meta;
    if (!multiplier || multiplier==1)
        return null;
    const icon = multiplier_icon
        ? <span>{multiplier_icon}</span>
        : null;
    return <div className={cns.mult}>
      <Text.s tip={multiplier_hint} placement="bottom">
        {icon}
        <Text.s span className={cns.label}>
          Earnings{' '}<br className={cns.br}/>multiplier is:
        </Text.s>
        {' '}
        <Text.s bold span className={cns.value}>
          {multiplier}
        </Text.s>
      </Text.s>
    </div>;
};

export function Total_earnings({className}){
    const [meta] = store.use_money();
    let title = get_tooltip(meta);
    return <div className={cn(cns.root, className)}>
      <div className={cns.icon_wrap}>
        <Icon ico="cash" color="accent"/>
      </div>
      <Text.s className={cns.wrap}>
        <Text.s span className={cns.label}>Lifetime earnings</Text.s>
        {' '}
        <Text.l span bold className={cns.value} tip={title}>
          {fmt_money(meta.earnings_total)}
        </Text.l>
      </Text.s>
      {get_mult(meta)}
    </div>;
}
